// import { SurveyQuestion } from '@/types/survey.types';
// import * as ExcelJS from 'exceljs';

// interface Choice {
//   list_name: string;
//   name: string;
//   label: string;
//   [key: string]: any;
// }

// interface Setting {
//   default_language?: string;
//   [key: string]: any;
// }

// export interface ConvertedSurveyData {
//   questions: SurveyQuestion[];
//   languages: Array<{ value: string; name: string; code: string }>;
//   defaultLanguage?: string;
// }

// const mapSurveyAndChoices = async (
//   surveyJson: any[],
//   choicesJson: Choice[],
//   settingJson: Setting[],
// ) => {
//   const choiceMap: Record<string, Choice[]> = {};

//   for (let choice of choicesJson) {
//     if (!choiceMap[choice.list_name]) {
//       choiceMap[choice.list_name] = [];
//     }
//     choiceMap[choice.list_name].push(choice);
//   }

//   let defaultLanguage: string | number | undefined;
//   for (let setting of settingJson) {
//     if (setting.default_language) {
//       const langValue = setting.default_language;
//       if (typeof langValue === 'string' && langValue.includes('(')) {
//         const match = langValue.match(/\((.+)\)/);
//         defaultLanguage = match?.[1] || langValue;
//       } else {
//         defaultLanguage = langValue;
//       }
//     }
//   }

//   for (let survey of surveyJson) {
//     if (survey.type?.startsWith('select_one') || survey.type?.startsWith('select_multiple')) {
//       const arr: string[] = survey.type.split(' ');
//       if (arr[1] && choiceMap[arr[1]]) {
//         survey.options = choiceMap[arr[1]];
//       }
//     }
//     survey.defaultLanguage = defaultLanguage;
//   }

//   return surveyJson;
// };

// export const convertExcelToSurveyJson = async (file: File): Promise<ConvertedSurveyData> => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();

//     reader.onload = async (e) => {
//       try {
//         const buffer = e.target?.result as ArrayBuffer;
//         const workbook = new ExcelJS.Workbook();
//         await workbook.xlsx.load(buffer);

//         if (workbook.worksheets.length < 3) {
//           reject(
//             new Error(
//               `Excel file must contain at least 3 sheets. Found: ${
//                 workbook.worksheets.length
//               } sheets (${workbook.worksheets.map((ws) => ws.name).join(', ')})`,
//             ),
//           );
//           return;
//         }

//         const surveySheet = workbook.worksheets[0];
//         const choicesSheet = workbook.worksheets[1];
//         const settingSheet = workbook.worksheets[2];

//         if (!surveySheet || !choicesSheet || !settingSheet) {
//           reject(new Error('One or more required sheets are missing or empty'));
//           return;
//         }

//         const surveyJson = convertWorksheetToJson(surveySheet);
//         const choicesJson = convertWorksheetToJson(choicesSheet) as Choice[];
//         const settingJson = convertWorksheetToJson(settingSheet) as Setting[];

//         if (!surveyJson.length) {
//           reject(new Error('Survey sheet is empty or has no valid data'));
//           return;
//         }

//         const mappedSurvey = await mapSurveyAndChoices(surveyJson, choicesJson, settingJson);

//         const parsedQuestions: SurveyQuestion[] = mappedSurvey.map((item: any, index: number) => {
//           const question: any = {
//             name: String(item.name || `question_${index + 1}`),
//             type: String(item.type || 'text'),
//             label: String(item.label || `Question ${index + 1}`),
//             required: item.required ? String(item.required) : 'no',
//             hint: item.hint ? String(item.hint) : undefined,
//             constraint: item.constraint ? String(item.constraint) : undefined,
//             constraint_message: item.constraint_message
//               ? String(item.constraint_message)
//               : undefined,
//             options: item.options || undefined,
//           };

//           Object.keys(item).forEach((key) => {
//             if (key.startsWith('label::')) {
//               question[key] = item[key];
//             }
//           });

//           return question;
//         });

//         let languages: Array<{ value: string; name: string; code: string }> = [];
//         let defaultLanguage: string | undefined;

//         if (parsedQuestions.length > 0) {
//           const firstQuestion = parsedQuestions[0] as any;
//           languages = Object.keys(firstQuestion)
//             .filter((key) => key.startsWith('label::'))
//             .map((key) => {
//               const lang = key.replace('label::', '').trim();
//               const match = lang.match(/(.+)\((.+)\)/);
//               return {
//                 value: lang,
//                 name: match?.[1]?.trim() ?? lang,
//                 code: match?.[2]?.trim() ?? '',
//               };
//             });

//           if (languages.length > 0 && mappedSurvey[0]?.defaultLanguage) {
//             const defaultLang = mappedSurvey[0].defaultLanguage;
//             const matchingLang = languages.find(
//               (l) => l.code === defaultLang || l.value === defaultLang || l.name === defaultLang,
//             );
//             defaultLanguage = matchingLang?.value || languages[0].value;
//           } else if (languages.length > 0) {
//             defaultLanguage = languages[0].value;
//           }
//         }

//         resolve({
//           questions: parsedQuestions,
//           languages,
//           defaultLanguage,
//         });
//       } catch (error: any) {
//         reject(new Error(`Failed to parse Excel file: ${error.message}`));
//       }
//     };

//     reader.onerror = () => reject(new Error('Failed to read file'));
//     reader.readAsArrayBuffer(file);
//   });
// };

// const convertWorksheetToJson = (worksheet: ExcelJS.Worksheet): any[] => {
//   const result: any[] = [];
//   const headers: string[] = [];

//   const headerRow = worksheet.getRow(1);
//   headerRow.eachCell((cell, colNumber) => {
//     headers[colNumber - 1] = cell.value?.toString() || '';
//   });

//   worksheet.eachRow((row, rowNumber) => {
//     if (rowNumber === 1) return;

//     const rowData: any = {};
//     row.eachCell((cell, colNumber) => {
//       const header = headers[colNumber - 1];
//       if (header) {
//         rowData[header] = cell.value;
//       }
//     });

//     if (Object.keys(rowData).length > 0) {
//       result.push(rowData);
//     }
//   });

//   return result;
// };
import { SurveyQuestion } from '@/types/survey.types';
import * as ExcelJS from 'exceljs';

interface Choice {
  list_name: string;
  name: string;
  label: string;
  [key: string]: any;
}

interface Setting {
  default_language?: string;
  [key: string]: any;
}

export interface ConvertedSurveyData {
  questions: SurveyQuestion[];
  languages: Array<{ value: string; name: string; code: string }>;
  defaultLanguage?: string;
}

/* ------------------------------------------
   NEST begin_repeat / begin_group PROPERLY
------------------------------------------ */
const nestSurveyRows = (rows: any[]) => {
  const result: any[] = [];
  const stack: any[] = [];

  for (const row of rows) {
    const type = row.type?.toLowerCase()?.trim();

    if (type === 'begin_repeat' || type === 'begin_group') {
      const container = {
        ...row,
        questions: [],
      };
      stack.push(container);
    } else if (type === 'end_repeat' || type === 'end_group') {
      const completed = stack.pop();

      if (stack.length > 0) {
        stack[stack.length - 1].questions.push(completed);
      } else {
        result.push(completed);
      }
    } else {
      if (stack.length > 0) {
        stack[stack.length - 1].questions.push(row);
      } else {
        result.push(row);
      }
    }
  }

  return result;
};

/* ------------------------------------------
   MAP SELECT CHOICES
------------------------------------------ */
const mapSurveyAndChoices = async (
  surveyJson: any[],
  choicesJson: Choice[],
  settingJson: Setting[],
) => {
  const choiceMap: Record<string, Choice[]> = {};

  for (let choice of choicesJson) {
    if (!choiceMap[choice.list_name]) {
      choiceMap[choice.list_name] = [];
    }
    choiceMap[choice.list_name].push(choice);
  }

  let defaultLanguage: string | number | undefined;

  for (let setting of settingJson) {
    if (setting.default_language) {
      const langValue = setting.default_language;

      if (typeof langValue === 'string' && langValue.includes('(')) {
        const match = langValue.match(/\((.+)\)/);
        defaultLanguage = match?.[1] || langValue;
      } else {
        defaultLanguage = langValue;
      }
    }
  }

  for (let survey of surveyJson) {
    if (survey.type?.startsWith('select_one') || survey.type?.startsWith('select_multiple')) {
      const arr: string[] = survey.type.split(' ');
      if (arr[1] && choiceMap[arr[1]]) {
        survey.options = choiceMap[arr[1]];
      }
    }

    survey.defaultLanguage = defaultLanguage;
  }

  return surveyJson;
};

/* ------------------------------------------
   BUILD QUESTIONS RECURSIVELY
------------------------------------------ */
const buildQuestions = (items: any[]): SurveyQuestion[] => {
  return items.map((item: any, index: number) => {
    const question: any = {
      name: String(item.name || `question_${index + 1}`),
      type: String(item.type || 'text'),
      required: item.required ? String(item.required) : 'no',
      hint: item.hint ? String(item.hint) : undefined,
      constraint: item.constraint ? String(item.constraint) : undefined,
      constraint_message: item.constraint_message ? String(item.constraint_message) : undefined,
      options: item.options || undefined,
    };

    // multilingual labels
    Object.keys(item).forEach((key) => {
      if (key.startsWith('label::')) {
        question[key] = item[key];
      }
    });

    // nested children (repeat/group)
    if (item.questions && item.questions.length > 0) {
      question.questions = buildQuestions(item.questions);
    }

    return question;
  });
};

/* ------------------------------------------
   MAIN CONVERTER
------------------------------------------ */
export const convertExcelToSurveyJson = async (file: File): Promise<ConvertedSurveyData> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const buffer = e.target?.result as ArrayBuffer;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);

        if (workbook.worksheets.length < 3) {
          reject(
            new Error(
              `Excel file must contain at least 3 sheets. Found: ${workbook.worksheets.length}`,
            ),
          );
          return;
        }

        const surveySheet = workbook.worksheets[0];
        const choicesSheet = workbook.worksheets[1];
        const settingSheet = workbook.worksheets[2];

        const surveyJson = convertWorksheetToJson(surveySheet);
        const choicesJson = convertWorksheetToJson(choicesSheet) as Choice[];
        const settingJson = convertWorksheetToJson(settingSheet) as Setting[];

        if (!surveyJson.length) {
          reject(new Error('Survey sheet is empty'));
          return;
        }

        const mappedSurvey = await mapSurveyAndChoices(surveyJson, choicesJson, settingJson);

        // 🔥 IMPORTANT: NEST BEFORE BUILDING QUESTIONS
        const nestedSurvey = nestSurveyRows(mappedSurvey);

        const parsedQuestions: SurveyQuestion[] = buildQuestions(nestedSurvey);

        /* ------------------------------------------
           LANGUAGE EXTRACTION
        ------------------------------------------ */

        let languages: Array<{
          value: string;
          name: string;
          code: string;
        }> = [];
        let defaultLanguage: string | undefined;

        if (parsedQuestions.length > 0) {
          const firstQuestion = parsedQuestions[0] as any;

          languages = Object.keys(firstQuestion)
            .filter((key) => key.startsWith('label::'))
            .map((key) => {
              const lang = key.replace('label::', '').trim();
              const match = lang.match(/(.+)\((.+)\)/);

              return {
                value: lang,
                name: match?.[1]?.trim() ?? lang,
                code: match?.[2]?.trim() ?? '',
              };
            });

          if (languages.length > 0 && mappedSurvey[0]?.defaultLanguage) {
            const defaultLang = mappedSurvey[0].defaultLanguage;

            const matchingLang = languages.find(
              (l) => l.code === defaultLang || l.value === defaultLang || l.name === defaultLang,
            );

            defaultLanguage = matchingLang?.value || languages[0].value;
          } else if (languages.length > 0) {
            defaultLanguage = languages[0].value;
          }
        }

        resolve({
          questions: parsedQuestions,
          languages,
          defaultLanguage,
        });
      } catch (error: any) {
        reject(new Error(`Failed to parse Excel file: ${error.message}`));
      }
    };

    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsArrayBuffer(file);
  });
};

/* ------------------------------------------
   WORKSHEET TO JSON
------------------------------------------ */
const convertWorksheetToJson = (worksheet: ExcelJS.Worksheet): any[] => {
  const result: any[] = [];
  const headers: string[] = [];

  const headerRow = worksheet.getRow(1);

  headerRow.eachCell((cell, colNumber) => {
    headers[colNumber - 1] = cell.value?.toString() || '';
  });

  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber === 1) return;

    const rowData: any = {};

    row.eachCell((cell, colNumber) => {
      const header = headers[colNumber - 1];
      if (header) {
        rowData[header] = cell.value;
      }
    });

    if (Object.keys(rowData).length > 0) {
      result.push(rowData);
    }
  });

  return result;
};
